import * as http from '../http'
import { buildApiUrl } from './apiUrl'

export function apiGetTasks(userId: string) {
  return http.get(buildApiUrl(`EngagementTasks/${userId}`))
}
